import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SiteSettingsContext = createContext(null);
export const useSiteSettings = () => useContext(SiteSettingsContext) || {};

const DEFAULT_CATEGORIES = [
  { slug: "jackets", label: "JACKETS" },
  { slug: "tees", label: "TEES" },
  { slug: "jeans", label: "JEANS" },
  { slug: "tote-bags", label: "TOTES" },
  { slug: "tops", label: "TOPS" },
  { slug: "thrifted", label: "THRIFTED" },
];

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    logo: "/outlawd-logo.jpg",
    seo_title: "OUTLAW-D · Wear Your Rebellion",
    seo_description: "Custom streetwear + curated thrift from India.",
    contact_phone: "+91 91527 63208",
    contact_whatsapp: "+919152763208",
    contact_hours: "Mon-Sat · 10 AM - 7 PM IST",
    categories: DEFAULT_CATEGORIES,
    category_images: {},
    hero_image: "",
  });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site/settings");
      setSettings((prev) => ({ ...prev, ...data, categories: data.categories?.length ? data.categories : DEFAULT_CATEGORIES }));
      // Update document title + meta description dynamically
      if (data.seo_title) document.title = data.seo_title;
      const meta = document.querySelector('meta[name="description"]');
      if (meta && data.seo_description) meta.setAttribute("content", data.seo_description);
    } catch (err) {
      console.warn("site settings load failed", err);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <SiteSettingsContext.Provider value={{ ...settings, refresh }}>{children}</SiteSettingsContext.Provider>;
}
